module.exports = __webpack_public_path__ + "static/media/han_pai_spr.eaad9104.png";